<template>
  <AbsPopup id="publishingPostList" title="책으로 만들 글을 선택해 주세요" @close="$emit('close')" @submit="submit">
    <template #body>
      <div class="body">
        <li v-for="(item, index) in getList" :key="index" class="postItem">
          <input type="checkbox" :id="'item' + index" v-model="item.checked" :disabled="item.disable" :checked="item.checked" @change="checkChange"/>
          <label :for="'item' + index">
            <span v-if="item.checked">{{ getBookName(item) }}</span>
            <span>{{ item.subtitle !== '' ? item.subtitle : '서브제목 없음' }}</span>
          </label>
        </li>
        <div class="length">
          <span>글자수 공백포함</span>
          <span>{{ getLength }}</span>
        </div>
      </div>
    </template>
  </AbsPopup>
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'
import UInput from '@/components/base/UInput.vue'

export default {
  props: {
    option: {
      type: Object
    }
  },
  created () {
  },
  mounted () {
    console.log(this.option)
    this.$http.post('/api/publishing/getPost', {contract: this.option.param.contract, book: this.option.param.book}).then((e) => {
      console.log('getPost', e)
      if (e.success) {
        var dump = []
        this.option.param.list.forEach((item, idx) => {
          console.log(item)
          var ob = {subtitle: item.subtitle, postID: item._id, length: item.length}
          if (item.checked) {
            ob.checked = true
          }
          dump.push(ob)
        })
        e.data.forEach((item, i) => {
          item.postList.forEach((post, i) => {
            var fitem = dump.find(l => l.postID === post)
            if (item._id !== this.option.param.epub) {
              fitem.checked = true
              fitem.epubName = item.name
              fitem.epubID = item._id
              fitem.disable = true
            } else {
              fitem.epubName = this.option.param.bookname
              fitem.epubID = item._id
            }
          })
        })
        this.list = dump
        this.$emit('loading', false)
      } else {
      }
    })
  },
  data () {
    return {
      list: []
    }
  },
  name: 'PublishingPostList',
  computed: {
    getList () {
      if (this.list) {
        return this.list
      }
      return []
    },
    getLength () {
      var t = 0
      this.list.forEach((item, i) => {
        if (!item.disable && item.checked) {
          t += item.length
        }
      })
      switch (t.toString().length) {
        case 1 :
        case 2 :
        case 3 :
          return t + '자'
        case 4 :
          return (t / 1000) + '천자'
        case 5 :
        case 6 :
        case 7 :
          return (t / 10000) + '만자'
        default :
          return (t / 10000000) + '천만자'
      }
    }
  },
  methods: {
    getBookName (item) {
      console.log(item)
      if (item.epubName) {
        return item.epubName
      }
      return this.option.param.bookname
    },
    checkChange (e) {
      console.log(e)
    },
    checkItem (item) {
    },
    submit () {
      var data = []
      this.list.forEach((item, idx) => {
        if (!item.disable) {
          var p = this.option.param.list.find((post, pidx) => post._id === item.postID)
          if (p.checked !== item.checked) {
            data.push({id: item.postID, checked: item.checked})
          }
        }
      })
      this.$emit('submit', data)
    }
  },
  components: {
    AbsPopup,
    UInput
  }
}
</script>

<style scoped>
#publishingPostList {
  padding: 10px 0;
  width: 400px;
}
.body {
  display: flex;
  flex-direction: column;
  width: 100%;
  line-height: 30px;
  padding: 0px;
  margin: 0px;
  min-height: 210px;
  max-height: calc(100vh - 150px);
  overflow-y: auto;
}
.postItem {
  display: flex;
  flex-direction: row;
}
.postItem input[type=checkbox] {
  display: none;
}
.postItem input[type=checkbox] + label {
  display: flex;
  width: 100%;
  height: 100%;
  text-align: left;
  margin: 4px;
}
.postItem input[type=checkbox] + label span:first-child {
  flex: 1;
  padding-left: 20px;
  background-color: var(--disable);
}
.postItem input[type=checkbox]:checked + label {
  color: var(--bg-white);
}
.postItem input[type=checkbox]:checked + label span:first-child {
  max-width: 150px;
  text-align: right;
  padding-right: 10px;
  background-color: var(--line-title);
}
.postItem input[type=checkbox]:checked + label span:last-child {
  flex: 1;
  padding-left: 20px;
  background-color: var(--line-base);
}
.length {
  display: flex;
  flex-direction: row;
  margin-top: auto;
  padding: 0px 20px;
  border-top: 1px solid var(--line-guide);
}
.length span:last-child {
  margin-left: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/PublishingPostList.vue